export default function tiposReembolsoTexto(configuracao) {
  const tipos = ['diárias'];

  if (configuracao && configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb) {
    tipos.push('passagens');
  }

  if (configuracao && configuracao.utilizarSolicitacaoAdiantamentoWeb) {
    tipos.push('adiantamentos');
  }

  return tipos.join('/');
}



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-reembolso-texto.js